import {
  IconGlobeRegular,
  IconMailFill,
  IconPhoneFill,
  IconTelegramDark,
  IconVkDark,
  IconWhatsappDark,
  IconYoutubeDark,
} from "@packages/icon-library";

export function formatPlaceContact(contact: {
  text: string;
  type: string;
  value: string;
}) {
  switch (contact.type) {
    case "phone":
      return {
        text: contact.text,
        link: `tel:${contact.value}`,
        icon: IconPhoneFill,
      };
    case "email":
      return {
        text: contact.text,
        link: `mailto:${contact.value}`,
        icon: IconMailFill,
      };
    case "url_website":
      return {
        text: contact.text,
        link: contact.value,
        icon: IconGlobeRegular,
      };
    case "url_vk":
      return { text: contact.text, link: contact.value, icon: IconVkDark };
    case "url_facebook":
      return { text: contact.text, link: contact.value, icon: "" };
    case "url_twitter":
      return { text: contact.text, link: contact.value, icon: "" };
    case "url_instagram":
      return { text: contact.text, link: contact.value, icon: "" };
    case "url_youtube":
      return { text: contact.text, link: contact.value, icon: IconYoutubeDark };
    case "url_telegram":
      return {
        text: contact.text,
        link: contact.value,
        icon: IconTelegramDark,
      };
    case "url_whatsapp":
      return {
        text: contact.text,
        link: contact.value,
        icon: IconWhatsappDark,
      };
    default:
      return "";
  }
}
